import React from "react";
import MoneyBackGuarantee from "../../images/money-back.svg";
import "./OurPromise.scss";
const OurPromise = ({isInCard=false}) => {
  return (
    <section className={`our-promise ${isInCard && "our-promise-in-card"}`}>
      <div className="container">
        <div className="our-promise__header">
          <h2>Our Promise</h2>
        </div>

        <div className="our-promise__guarantee">
          <figure>
            <img
              src={MoneyBackGuarantee}
              alt="money-back-guarantee-100%"
              loading="lazy"
            />
          </figure>

          <p>
            <span className="our-promise__header desk">
              <span className="sub-header">Our Promise</span>
            </span>
            If you don’t like our service, for any reason, simply inform the
            delivery partner before taking delivery and we’ll refund every penny
            – no questions asked!
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurPromise;
